/* eslint-disable no-shadow */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/no-unused-state */
import React from "react";
import { connect } from "react-redux";
import Hidden from "@material-ui/core/Hidden";
import {
  FormControl, InputLabel, MenuItem, Select,
} from "@material-ui/core";
import { PageWrapper } from "../../../shared/layout";
import {
  BarLoader, ExportButton, ConfirmationModal, Search as SearchBar, Button,
} from "../../../shared/widgets";
import "./contractStyle.css";
import CreateContractModal from "./createContract/createContract";
import { MessageType } from "../../../Constant";
import { contractType, setContractStateData } from "../../../redux/actions/contractedVehicleAction";
import { setNotificationMessage } from "../../../redux/actions/notificationAction";
import { closeActiveContractsService, closeUpcomingContractsService } from "../../../services/contractService";
import { getListUtil } from "../../../shared/utils";
import VehicleList from "./listView/vehiclesList";
import { fetchVehicleListAction } from "../../../redux/action-creators/contractedActionCreator";

class ContractWrapper extends React.Component {
  static getDerivedStateFromProps(nextProps) {
    if (nextProps.contractStateData?.contractType) {
      return {
        contractType: nextProps.contractStateData?.contractType || "all",
        pageNo: nextProps.contractStateData?.pageNo || 0,
        rowsPerPage: nextProps.contractStateData?.rowsPerPage || 10,
      };
    }
    return null;
  }

  constructor(props) {
    super(props);

    this.state = {
      pageNo: 0,
      rowsPerPage: 10,
      count: 100,
      backdrop: false,
      totalPages: 0,
      activeStep: 0,
      steps: this.getSteps(),
      selected: [],
      searchString: "",
      isUpdated: false,
      showConfirmationModal: false,
      contractType: "all",
      // errorContent: null,
    };
    this.handleTabChange = this.handleTabChange.bind(this);
    this.displayConfirmationModal = this.displayConfirmationModal.bind(this);
    this.showNotification = this.showNotification.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleVehicleSelection = this.handleVehicleSelection.bind(this);
  }

  handleChange = (event) => {
    this.setState({ contractType: event.target.value, selected: [] }, () => {
    });
  };

  handleTabChange(value) {
    const { updateContractType } = this.props;
    updateContractType({ contractType: value });
    this.setState({ page: 0, selected: [] });
  }

  handleSearchChange = (e) => {
    this.setState({
      searchString: e,
    });
  };

  handleVehicleSelection(selectedVehicles) {
    const { content } = this.props;
    const selectedVehicleArray = content.filter((
      vehicle,
    ) => selectedVehicles.includes(vehicle.busNumber));
    this.setState({
      selected: selectedVehicleArray,
    });
  }

  getSteps() {
    return ["Terms", "Commercials"];
  }

  showNotification(type, msg) {
    const { initiateNotification } = this.props;
    initiateNotification({
      type,
      message: msg || "Something went wrong",
    });
  }

  /**
   * Used to show Modal for "Add new Contract"
   */

  displayConfirmationModal() {
    const { showConfirmationModal, contractType: contractTypeState, selected } = this.state;
    const { fetchVehicleListAction: fetchVehicleListActionProp, setTokenExpired } = this.props;
    return (
      <ConfirmationModal
        showModal={showConfirmationModal}
        title="Are you sure you want to terminate selected contracts?"
        yesButtonText="Terminate"
        messageCallBack={(type) => {
          if (type === MessageType.SUCCESS) {
            (contractTypeState === "active" ? closeActiveContractsService(selected.map((bus) => bus.busNumber)) : closeUpcomingContractsService(selected.map((bus) => bus.busNumber)))
              .then(() => {
                this.showNotification(MessageType.SUCCESS, "Contracts terminated successfully");
                getListUtil({
                  dispatchFn: fetchVehicleListActionProp, props: this.props, state: this.state,
                });
              })
              .catch((err) => {
                if (err.message.includes("Invalid token")) {
                  setTokenExpired(true);
                } else {
                  this.showNotification(MessageType.ERROR, err.message);
                }
              });
          }
          this.setState({ showConfirmationModal: false, selected: [] });
        }}
      />
    );
  }

  /**
   * Call when Add modal Opens.
   */
  open(data, requestType) {
    this.setState({
      showModal: true,
      requestType,
    });
  }

  displayModal() {
    const {
      showModal, activeStep, selected, steps, requestType, isUpdated,
    } = this.state;
    const { city, fetchVehicleListAction: fetchVehicleList, initiateNotification } = this.props;
    return (
      <CreateContractModal
        showModal={showModal}
        activeStep={activeStep}
        selectedVehicle={selected}
        steps={steps}
        city={city}
        requestType={requestType}
        messageCallBack={(type, msg) => {
          if (type) {
            if (type === MessageType.SUCCESS) {
              getListUtil({ dispatchFn: fetchVehicleList, props: this.props, state: this.state });
              this.setState({
                selected: [],
                isUpdated: !isUpdated,
              });
            }
            initiateNotification({
              type,
              message: msg,
            });
          }
          if (type !== MessageType.ERROR) {
            this.setState({
              showModal: false,
              activeStep: 0,
            });
          }
        }}
      />
    );
  }

  render() {
    const {
      city, operator, refreshUpliftStatus, contractStateData,
      setContractStateData: setContractStateDataProp,
    } = this.props;
    const {
      contractType: contractTypeState, selected, searchString, showModal, showConfirmationModal,
    } = this.state;
    const endpoint = "contractsPage/exportContractedBuses";
    const exportContractedBusesQuery = {
      addOnFilter: {
        cityIdArr: city,
        operatorIdArr: operator,
      },
      status: contractTypeState,
    };
    return (
      <div className="pageContainer">
        <PageWrapper>
          <PageWrapper.Header heading="Contracts" hideS>
            <Hidden only={["sm", "xs"]}>
              <div className="pull-right">
                <div className="progress-heading">
                  <span>{refreshUpliftStatus || ""}</span>
                </div>
              </div>
              <div className="btn-wrapper">
                {(contractTypeState === "noContract"
                  || contractTypeState === "expired") && (
                  <div>
                    <div className="btn-wrapper">
                      <Button
                        disable={selected?.length === 0}
                        onClick={() => this.open(this, "create")}
                        buttonText="Create New Contract"
                      />
                    </div>
                  </div>
                )}
                {(contractTypeState === "active"
                  || contractTypeState === "upcoming") && (
                  <div>
                    <div className="btn-wrapper">
                      <Button
                        disable={selected?.length === 0}
                        onClick={() => this.setState({ showConfirmationModal: true })}
                        buttonText="Terminate"
                      />
                    </div>
                  </div>
                )}
                <div className="pull-right">
                  <ExportButton
                    query={exportContractedBusesQuery}
                    endpoint={endpoint}
                    pageName="Contract"
                    isDisable={
                      refreshUpliftStatus === "Data Sync In Process"
                    }
                  />
                </div>
                <div className="pull-right search-container">
                  <FormControl
                    variant="outlined"
                    style={{ width: 140, height: 32 }}
                  >
                    <InputLabel
                      id="demo-simple-select-helper-label"
                      style={{ lineHeight: "15px" }}
                    >
                      Type
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-helper-label"
                      id="demo-simple-select-helper"
                      value={contractStateData?.contractType || contractTypeState}
                      label="Age"
                      onChange={this.handleChange}
                      style={{ height: 32, lineHeight: "32px" }}
                    >
                      <MenuItem value="all">All</MenuItem>
                      <MenuItem value="active">Active</MenuItem>
                      <MenuItem value="upcoming">Upcoming</MenuItem>
                      <MenuItem value="expired">Expired</MenuItem>
                      <MenuItem value="noContract">No Contract</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                <div className="pull-right search-container">
                  <SearchBar
                    placeHolder="Search Vehicle"
                    onSearchChange={this.handleSearchChange}
                  />
                </div>
              </div>
            </Hidden>
          </PageWrapper.Header>
          <PageWrapper.Body customClass="contract-body">
            <BarLoader scope="header" />
            <VehicleList
              searchString={searchString}
              selected={selected}
              handleVehicleSelection={this.handleVehicleSelection}
              contractType={contractTypeState}
              setContractStateData={setContractStateDataProp}
            />
            {showModal && this.displayModal()}
            {showConfirmationModal
              && this.displayConfirmationModal()}
          </PageWrapper.Body>
        </PageWrapper>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    content: state?.Contracts?.contractList?.items || [],
    value: state.Contracts.contractType,
    city: state.Cities.selectedCity,
    operator: state.Operators.selectedOperator,
    refreshUpliftStatus: state && state.Contracts && state.Contracts.refreshUpliftStatus,
    contractStateData: state?.Contracts?.contractStateData,

  };
}
const mapDispatchToProps = (dispatch) => ({
  updateContractType: (params) => {
    dispatch(contractType(params));
  },
  fetchVehicleListAction: (params) => {
    dispatch(fetchVehicleListAction(params));
  },
  initiateNotification: (value) => {
    dispatch(setNotificationMessage(value));
  },
  setContractStateData: (value) => {
    dispatch(setContractStateData(value));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(ContractWrapper);
